@if (!contentLoaded) {
  <app-content-loader></app-content-loader>
}
@if (contentLoaded) {
  <div class="step-container columns is-desktop">
    <app-aside-bar [showEvenWithoutStatement]="false" [statement]="statement" [isBusiness]="isBusiness">
    </app-aside-bar>
    <div class="finish">
      @if (statement.serviceType!==packageOption.tax_adviser) {
        <div class="finish__wrapper">
          <div class="finish__header">
            <h1 class="title_42" translate="FINISH.TITLE"></h1>
            <p class="subdesc">
              {{'FINISH.DESCRIPTION' | translate }}
            </p>
          </div>
          <div class="finish__img">
            <ng-lottie [options]="lottieConfig" ></ng-lottie>
          </div>
        </div>
      }
      @if (statement.serviceType===packageOption.tax_adviser) {
        <div class="finish__wrapper">
          <div class="finish__header">
            <h1 class="title_42" translate="FINISH.TITLE"></h1>
            <p class="subdesc">
              {{'FINISH.TAX_ADVISER_DESCRIPTION' | translate}}
            </p>
          </div>
          <div class="finish__img">
            <ng-lottie [options]="lottieConfig" ></ng-lottie>
          </div>
        </div>
      }
    </div>
    <app-tools-bar [statement]="statement" [buttons]="buttons"></app-tools-bar>
  </div>
}
